define('common/ko/extension/moment',['underscore', 'knockout', 'common/tools'], function (_, ko, tools) {

    ko.subscribable.fn.settings = ko.subscribable.fn.settings || ko.observable();

    ko.extenders.moment = function(m, conf) {

        conf = _.extend({
            format: 'YYYY-MM-DD HH:mm:ss',
            tickInterval: 5000
        }, conf);

        var tick = ko.observable(0),
            intervalId;

        function getLanguage() {
            return m.settings() && m.settings().selectedLanguage();
        }

        // Adds a dependency on the selectedLanguage to trigger recompute on change
        function dependsOnSelectedLanguage() {
            getLanguage();
        }

        function formatMoment(format) {
            var locale = getLanguage(),
                _moment = m() ? m().locale(locale.code) : undefined;

            if (_.isUndefined(_moment) || !_moment.isValid()) {
                return 'N/A';
            }

            return _moment.format(format);
        }

        m.formattedMoment = ko.pureComputed(function() {
            return formatMoment(ko.unwrap(conf.format));
        });

        m.formatMoment = _.memoize(function(format) {
            return ko.pureComputed(function() {
                return formatMoment(format);
            });
        });

        m.fromNow = ko.pureComputed(function() {

            var _moment = m();

            dependsOnSelectedLanguage();
            tick(); //Depend on tick to update this computed once every conf.tickInterval ms

            if (_.isUndefined(_moment) || !_moment.isValid()) {
                return 'N/A';
            }

            _moment.locale(false); //make sure moment doesn't have an instance locale set here. See http://momentjs.com/docs/#/i18n/instance-locale/

            return _moment.fromNow();

        });

        // Start the ticker when the computed is awake
        m.fromNow.subscribe(function() {

            if(conf.tickInterval !== -1) {
                intervalId = window.setInterval(
                    function() {
                        tick(tick() + 1);
                    },
                    conf.tickInterval
                );
            }

        }, null, 'awake');

        // ... and stop it when it's not
        m.fromNow.subscribe(function() {
            if(conf.tickInterval !== -1) {
                window.clearInterval(intervalId);
            }
        }, null, 'asleep');

        //Manipulations on the underlying moment (m)
        m.add = function(t, n) {
            m.valueWillMutate();
            m().add(t, n);
            m.valueHasMutated();
            return false;
        };
        m.subtract = function(t, n) {
            m.valueWillMutate();
            m().subtract(t, n);
            m.valueHasMutated();
            return false;
        };
        m.set = function(t, n) {
            m.valueWillMutate();
            m()[t](n);
            m.valueHasMutated();
            return false;
        };

        return m;
    };

});

